import React, { useEffect } from "react";
import "./Have_A_Question.css";
import { Accordion } from "react-bootstrap";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import { AllFaq } from '../../features/admin/footer/Slice';
import { useDispatch, useSelector } from 'react-redux';
const Have_A_Question = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();

  const all_faq = useSelector((state) => state.footer.all_faq);

  const faqList = all_faq?.data || all_faq || [];



  // console.log("all_faqall_faqall_faqall_faqall_faqdata", faqList);


  useEffect(() => {
    dispatch(AllFaq());
  }, [dispatch]);

  return (
    <section className="Have_A_Question">
      <div className="container">
        <Common_Back_Header backNavigation={-1} />
        <div className="main_content_div">
          <div className="first_img_div">
            <img
              src="/assets/images/have_a_question/img1.png"
              className="first_img"
            />
          </div>

          <div className="second_img_div">
            <div className="row">
              <div className="col-md-5">
                <div className="img_holder">
                  <img
                    src="/assets/images/have_a_question/img2.png"
                    className="second_img"
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="question_holder">
                  <p className="title_text">Your Questions, Our Guidance</p>

                  <div className="content_holder">
                    <Accordion defaultActiveKey="0">
                      {faqList &&
                        faqList.length > 0 &&
                        faqList.map((item, index) => (
                          <Accordion.Item
                            key={item.id}
                            className="outer_accordion_item"
                            eventKey={index.toString()}
                          >
                            <div className="inner_accordion_holder">
                              <Accordion.Header>
                                {item?.question || item?.Faq?.question || "No Question"}
                              </Accordion.Header>
                              <Accordion.Body>
                                {item?.answer || item?.Faq?.answer || "No Answer"}
                              </Accordion.Body>
                            </div>
                          </Accordion.Item>
                        ))}
                    </Accordion>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Have_A_Question;


